import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Route, Routes } from 'react-router-dom';
import FullPageLoading from './components/base/FullPageLoading';
import Layout from './components/layout/Layout';
import Album from './pages/Album';
import AlbumTags from './pages/AlbumTags';
import Albums from './pages/Albums';
import Main from './pages/Main';
import ManageAlbums from './pages/ManageAlbums';

const App = () => {
  const { isLoading: authIsLoading, isAuthenticated } = useAuth();

  if (authIsLoading) return <FullPageLoading />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route element={<Album />} path="album/:slug/:tagId?" />
        {isAuthenticated ? (
          <>
            <Route element={<Albums />} path="/" />
            <Route element={<ManageAlbums />} path="/albums" />
            <Route element={<AlbumTags />} path="/albumTags/:albumId" />
          </>
        ) : (
          <>
            <Route element={<Main />} path="/" />
          </>
        )}
      </Route>
    </Routes>
  );
};

export default App;
